import { render, staticRenderFns } from "./editPersonInfo.vue?vue&type=template&id=886005fc&scoped=true"
import script from "./editPersonInfo.vue?vue&type=script&lang=js"
export * from "./editPersonInfo.vue?vue&type=script&lang=js"
import style0 from "./editPersonInfo.vue?vue&type=style&index=0&id=886005fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886005fc",
  null
  
)

export default component.exports